<i18n>
{
  "en": {
    "components": {
      "pager": {
        "first": "First",
        "previous": "Previous",
        "next": "Next",
        "last": "Last",
        "page": "Page",
        "outOf": "out of"
      }
    }
  },
  "it": {
    "components": {
      "pager": {
        "first": "Prima",
        "previous": "Prec.",
        "next": "Succ.",
        "last": "Ultima",
        "page": "Pagina",
        "outOf": "di"
      }
    }
  }
}
</i18n>
<template>
  <div class="row mb-4">
    <div class="col">
      <b-button
        variant="primary"
        :disabled="pageNumber == 0"
        @click.prevent="selectPage(1)">
        {{ $t('components.pager.first') }}
      </b-button>
      <b-button
        variant="primary"
        :disabled="pageNumber == 0"
        @click.prevent="selectPage(pageNumber)">
        {{ $t('components.pager.previous') }}
      </b-button>
    </div>
    <div class="col text-center">
      <number-input-field
        :prepend="$t('components.pager.page')"
        :append="$t('components.pager.outOf') + ' ' + totalPages + '.'"
        :precision="0"
        :value="pageNumber + 1"
        @input="selectPage($event)">
      </number-input-field>
    </div>
    <div class="col text-right">
      <b-button
        variant="primary"
        :disabled="pageNumber == totalPages - 1"
        @click.prevent="selectPage(pageNumber + 2)">
        {{ $t('components.pager.next') }}
      </b-button>
      <b-button
        variant="primary"
        :disabled="pageNumber == totalPages - 1"
        @click.prevent="selectPage(totalPages)">
        {{ $t('components.pager.last') }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    page: {
      type: Object,
      required: true
    },

    numberField: {
      type: String,
      default: 'number'
    },

    totalPagesField: {
      type: String,
      default: 'totalPages'
    }
  },

  computed: {
    pageNumber() {
      return this.page[this.numberField];
    },

    totalPages() {
      return this.page[this.totalPagesField];
    }
  },

  methods: {
    selectPage(number) {
      console.log('Selecting page', number);
      if (number < 1) {
        number = 1;
      }
      if (number > this.page.totalPages) {
        number = this.page.totalPages;
      }
      this.$emit('input', number);
      return false;
    }
  }
};
</script>
